import React, { useContext, useState } from 'react';

import CheckboxPrompt from '@presenters/web/components/CheckboxPrompt';

import {
  DISTRICT_ROTARY_FOUNDATION_CHAIR_DRFC,
  DRFC_EMAIL,
  ROLE_3YR_COMMUNICATION_CONFIRMATION,
  ROTARY_FOUNDATION_CODE_OF_POLICIES,
} from '@domui-domain/districts';

import { DistrictContext } from '@domui-use-cases/districts';

import { useTranslation } from '@external/react-i18next';
import List from '@rotaryintl/harris-list';

export const use3yrRoleConfirmation = () => {
  const { t } = useTranslation();
  const [context] = useContext(DistrictContext);
  const {
    selectedInfo: { role },
  } = context;
  const is3yrRole = role?.termYears === 3;
  const [isCommunicationConfirmed, setIsCommunicationConfirmed] = useState(
    false
  );

  const DRFCConfirmationNotice = () => {
    return (
      <>
        <p>
          {t(
            'district-officers.drfc-foundation-code-policy',
            'By checking the box, I certify that this appointment meets the following criteria as required by The Rotary Foundation Code of Policies:'
          )}
        </p>
        <List listStyle="bulleted">
          <li>
            {t(
              'district-officers.drfc-foundation-code-policy-point-one',
              'All district governors selected to serve during the three-year DRFC term have provided their written approval of the candidate. The district has this document and can provide it to Rotary if requested.'
            )}
          </li>
          <li>
            {t(
              'district-officers.drfc-foundation-code-policy-point-two',
              'The DRFC candidate will not have served more than one term as a DRFC.'
            )}
          </li>
          <li>
            {t(
              'district-officers.drfc-foundation-code-policy-point-three',
              'The candidate doesn’t have either of these reports pending: the Annual Statement and Report of District Finances or the District Governor Funding Report.'
            )}
          </li>
          <li>
            {t(
              'district-officers.drfc-foundation-code-policy-point-four',
              'The candidate isn’t serving simultaneously in another club, district, or zone role that requires a significant time commitment. These roles include (but aren’t limited to) End Polio Now coordinator, endowment/major gifts adviser, regional Rotary Foundation coordinator, district governor, governor-elect, and governor-nominee.'
            )}
          </li>
        </List>
        <p>
          {t(
            'district-officers.drfc-foundation-code-policy-link',
            `To learn more about DRFC appointments, refer to <a href={{foundationCodeOfPolicesUrl}}>The Rotary Foundation Code of Policies</a> or write to <a href="mailto:{{drfcemail}}">{{drfcemail}}</a>.`,
            {
              foundationCodeOfPolicesUrl: ROTARY_FOUNDATION_CODE_OF_POLICIES,
              drfcemail: DRFC_EMAIL,
            }
          )}
        </p>
      </>
    );
  };

  const renderConfirmation = () =>
    is3yrRole ? (
      <CheckboxPrompt
        isChecked={isCommunicationConfirmed}
        toggleIsChecked={() =>
          setIsCommunicationConfirmed(!isCommunicationConfirmed)
        }
        prompt={
          role.name === DISTRICT_ROTARY_FOUNDATION_CHAIR_DRFC
            ? DRFCConfirmationNotice()
            : t(
                'district-officers.3yr-role-communication-confirmation',
                ROLE_3YR_COMMUNICATION_CONFIRMATION
              )
        }
      />
    ) : null;

  return { isCommunicationConfirmed, renderConfirmation };
};
